module.exports = __webpack_public_path__ + "static/media/Inter-Bold.78a81753.woff2";